/**
 * Manual dial entry point of the in-app dialer (spec 04 §2.5). Always an in-app route keyed by the
 * company id: the dialer loads the number itself, so no tel: URI is ever built from row data here.
 */
export const dialHref = (companyId: number | string) =>
  `/appeler?company_id=${encodeURIComponent(String(companyId))}`;
